import { render } from "./StudentsIndex.vue?vue&type=template&id=77948894&scoped=true"
import script from "./StudentsIndex.vue?vue&type=script&lang=js"
export * from "./StudentsIndex.vue?vue&type=script&lang=js"

import "./StudentsIndex.vue?vue&type=style&index=0&id=77948894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77948894"]])

export default __exports__